import { render, staticRenderFns } from "./TechnicalParameters.vue?vue&type=template&id=7b6417b4&"
import script from "./TechnicalParameters.vue?vue&type=script&lang=js&"
export * from "./TechnicalParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports